/**
 * Initialize and register the service worker
 * Import this file in your index.tsx or App.tsx
 */

import { registerServiceWorker } from "./utils/serviceWorker";

// Register the service worker
registerServiceWorker({
  onSuccess: (registration) => {
    console.log("Service Worker registered successfully:", registration);
  },
  onUpdate: (registration) => {
    console.log("Service Worker updated:", registration);
    // Silently update - the new version will be used on next page load
  },
});
